<template lang="pug">
.podcast-player
  .podcast-player__inner(
    v-if="embededUrl"
    style="position: relative; padding-bottom: 56.25%; height: 0;")
    iframe(
      :src="embededUrl"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      allow="autoplay"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;")
</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true
    }
  },

  computed: {
    embededUrl () {
      if (!this.entry) return null
      const videoUrl = this.entry?.video_url
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
      const match = videoUrl.match(regex)
      const videoId = match ? match[1] : null
      return videoId
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1`
        : null
    }
  },

  mounted () {
    this.$amplitude.track('OPEN_PODCAST_PLAYER', {
      slug: this.entry?.slug
    })
    this.$emit('open')
  },

  methods: {
    close () {
      this.$amplitude.track('CLOSE_PODCAST_PLAYER', {
        slug: this.entry?.slug
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.podcast-player {
  &__loader {
    aspect-ratio: 16 / 9;
  }
  &__inner {
    border-radius: 12px;
    overflow: hidden;
  }
}
</style>
